<template>
  <h4 v-if="showMore">Quellen</h4>
  <!--  <b-card id="source-panel" header="Quellen">-->
  <!--          <b-card id="source-panel-sources" header="Quellen">-->
  <!--            <b-card header="Quellen" style="margin: 10px" class="h-100">-->
  <div v-if="showMore" class="h-100">
    <div class="source-column-content-parent">
      <div class="source-column-content">
        <TransitionGroup name="list" tag="div">
          <!--      <li v-for="(sourceUid) of sourceOrder"-->
          <!--          :key="sourceUid">-->
          <!--        <a target="_blank" :href="sources.get(sourceUid)?.url_id">{{ sources.get(sourceUid)?.title }}</a>-->
          <!--      </li>-->
          <a target="_blank" :href="sources.get(sourceUid)?.url_id" v-for="(sourceUid) of sourceOrder"
             :key="sourceUid">
            <b-card class="source-card">{{ sources.get(sourceUid)?.title }}</b-card>
          </a>
        </TransitionGroup>
      </div>
    </div>

  </div>
  <div v-if="!showMore">
    <b-card>
      <p class="m-0">
        <BBadge>{{ sourceOrder.length }}</BBadge>
        Quellen für die KI-Zusammenfassung
      </p>
    </b-card>
  </div>
  <!--            </b-card>-->
  <!--          </b-card>-->
  <!--  </b-card>-->
</template>
<script setup lang="ts">
import type {Source} from "@/types.js";

const props = defineProps<{
  sources: Map<string, Source>,
  sourceOrder: string[],
  showMore: boolean
}>();
</script>
